import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceGql: DocumentNode = gql`
  fragment MetricsDisplayGridRowDataFragmentWithoutPersonalSpace on Metric {
    id
    name
    vizportalUrlId
    projectName
    projectVizportalUrlId
    underlyingView {
      name
      path
      workbook {
        vizportalUrlId
        name
      }
    }
    owner {
      domain
      username
      name
    }
  }
`;
